import React from "react";
import { bgColorOppositeShade, secondaryColor } from "../../utils/constants";

export default function SwitchWorkspaceIcon({ color = bgColorOppositeShade, stroke = secondaryColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.9 156.9">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <rect id="Rechteck_1" data-name="Rechteck 1" width="156.9" height="156.9" rx="23.54" fill={color} />
          <g id="Gruppe_8" data-name="Gruppe 8">
            <path
              id="browser-windows"
              d="M98.12,24.3a10.45,10.45,0,0,1,8.7,4.66L109,32.15H47.5a17,17,0,0,0-17,17v54L27.31,101a10.47,10.47,0,0,1-4.66-8.71V49.14A24.85,24.85,0,0,1,47.5,24.3Z"
              fill={stroke}
            />
            <path
              id="next-webpage"
              d="M48.58,37.11A12.89,12.89,0,0,0,35.71,50v57.34a14.06,14.06,0,0,0,14,14H80.31a30.38,30.38,0,0,1-4-9.36H49.75a4.69,4.69,0,0,1-4.68-4.68V62.86h70.21V76.05a30.28,30.28,0,0,1,9.36,5V50a12.89,12.89,0,0,0-12.87-12.87Zm0,9.36A3.51,3.51,0,1,1,45.07,50,3.51,3.51,0,0,1,48.58,46.47Zm11.7,0A3.51,3.51,0,1,1,56.77,50a3.51,3.51,0,0,1,3.51-3.51h0Zm14,0h37.44A3.51,3.51,0,0,1,115.28,50a3.57,3.57,0,0,1-3.51,3.58H74.32A3.57,3.57,0,0,1,70.81,50a3.51,3.51,0,0,1,3.51-3.51h0Z"
              fill={stroke}
            />
            <path
              id="Ausschluss_2"
              data-name="Ausschluss 2"
              d="M105.9,131.7a26.15,26.15,0,1,1,26.15-26.15A26.15,26.15,0,0,1,105.9,131.7Zm9.11-16h0a.36.36,0,0,1,.28.12.36.36,0,0,1,.11.29V119a1.89,1.89,0,0,0,3.78,0v-7.92a2.48,2.48,0,0,0-2.46-2.46h-7.92a1.89,1.89,0,0,0,0,3.77l3,.06a.4.4,0,0,1,.29.12.42.42,0,0,1,.12.3.4.4,0,0,1-.12.29l-.25.25a2,2,0,0,0-.31.19,12.08,12.08,0,0,1-14.51,0,1.93,1.93,0,0,0-2.55,2.88l.15.13a15.93,15.93,0,0,0,19.35,0,1.79,1.79,0,0,0,.28-.27l.53-.53A.33.33,0,0,1,115,115.7ZM94.48,90.21h0a1.8,1.8,0,0,0-1.33.55,1.88,1.88,0,0,0-.55,1.33V100A2.44,2.44,0,0,0,95,102.47H103a1.89,1.89,0,0,0,1.89-1.88h0a1.85,1.85,0,0,0-.56-1.33A1.88,1.88,0,0,0,103,98.7h-2.93a.42.42,0,0,1-.41-.41.46.46,0,0,1,.13-.29l.44-.44.06,0a12.09,12.09,0,0,1,14.5,0,1.92,1.92,0,0,0,2.4-3,15.92,15.92,0,0,0-19.31,0,2.65,2.65,0,0,0-.29.29l-.51.51a.4.4,0,0,1-.57,0,.46.46,0,0,1-.13-.29V92.09a1.88,1.88,0,0,0-1.87-1.88Z"
              fill={stroke}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
